import a from "./index37.js";
import { openBlock as r, createElementBlock as c, createElementVNode as o, withModifiers as i, toDisplayString as s } from "vue";
import "./index38.js";
import p from "../../../../_virtual/index.js";
const l = { class: "account" }, d = ["href"], f = { class: "account-text" }, g = ["href"], u = { class: "account-text" };
function m(e, n, k, h, _, v) {
  return r(), c("div", l, [
    o("a", {
      class: "account-link category-nav-link",
      href: e.createAccountURL,
      onClick: n[0] || (n[0] = i((...t) => e.openCreateAccountPage && e.openCreateAccountPage(...t), ["prevent"]))
    }, [
      o("span", f, s(e.t("header.create-free-account")), 1)
    ], 8, d),
    o("a", {
      class: "sign-in-link account-link category-nav-link",
      href: e.signInURL,
      onClick: n[1] || (n[1] = i((...t) => e.openSignInDialog && e.openSignInDialog(...t), ["prevent"]))
    }, [
      o("span", u, s(e.t("sign-in.sign-in")), 1)
    ], 8, g)
  ]);
}
const y = /* @__PURE__ */ p(a, [["render", m], ["__scopeId", "data-v-e234c9f7"]]);
export {
  y as default
};
//# sourceMappingURL=index26.js.map
